



































import { Component, Mixins } from 'vue-property-decorator'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import BasePage from '@/tcw/components/BasePage'
import { DISPLAY_DAY_FORMAT } from '@/tcw/domain/format'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import { kintaiInputStore } from '@/store/form/KintaiInputFormStore'
import KintaiInputForm from '../organisms/KintaiInputForm.vue'
import KintaiLockTag from '@/components/kintai/molecules/KintaiLockTag.vue'
import { KEY_CLASS_YOUBI_TYPE } from '@/tcw/constant/KeyClass'
import { TcwFormDate } from '@/tcw/domain/types'

@Component({
  components: { TcwLayoutBasicTemplate, KintaiInputForm, KintaiLockTag }
})
export default class KintaiInputPage extends Mixins(BasePage) {
  private saveAndNextFlg = false

  protected youbiStr = ''

  protected outputDay(day: TcwFormDate): string {
    return this.du.convertDateToStr(day, DISPLAY_DAY_FORMAT) + `(${this.youbiStr})`
  }
  protected mounted(): void {
    this.setYoubi(this.currentDate)
  }
  protected async setYoubi(day: Date): Promise<void> {
    const youbiCode = day.getDay() == 0 ? 7 : day.getDay() //getDayでは日曜日が0、DBでは日曜日が7になっているため変換している
    this.youbiStr = await this.codeLabel.getLabelByCode({
      keyClass: KEY_CLASS_YOUBI_TYPE,
      code: youbiCode as number
    })
  }
  protected get form(): FormStoreComponent {
    return this.$refs.form as FormStoreComponent
  }
  protected get isLock(): boolean {
    return kintaiInputStore.isLock
  }
  protected save(): void {
    this.saveAndNextFlg = false
    this.form.startSaveProc()
  }
  protected saveAndNext(): void {
    this.saveAndNextFlg = true
    this.form.startSaveProc()
  }
  protected successSave(): void {
    if (this.saveAndNextFlg) {
      this.nextDay()
    } else {
      this.back()
    }
  }
  protected nextDay(): void {
    this.$tcw.$store.basic.nextDate()
    this.form.init()
    this.setYoubi(this.currentDate)
  }
  protected prevDay(): void {
    this.$tcw.$store.basic.prevDate()
    this.form.init()
    this.setYoubi(this.currentDate)
  }
}
